import { render, staticRenderFns } from "./Subnavbar-funds.vue?vue&type=template&id=2a45bc7a&scoped=true"
import script from "./Subnavbar-funds.vue?vue&type=script&lang=js"
export * from "./Subnavbar-funds.vue?vue&type=script&lang=js"
import style0 from "./Subnavbar-funds.vue?vue&type=style&index=0&id=2a45bc7a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a45bc7a",
  null
  
)

export default component.exports